import React, { PropTypes } from 'react';
import { inject, observer } from 'mobx-react';
import { action, observable, toJS, autorun } from 'mobx';
import Log from "./Log";
import { FormActions, FormBody, SelectInput } from "../../../Form";
import Form from "../../../Form";
import { token } from '../../../../libs/localStorage';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import { BASE_URL } from '../../../../config';
import _ from 'lodash';
import moment from 'moment';
import * as api from '../../../../actions/api';
import Button from '../../../Form/Button';

@inject('ticketStore', 'userStore', 'inventoryItemStore', 'inventoryProductStore', 'stationStore')
@observer
export default class TicketLogRoot extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  }

  @observable logNote = false;
  @observable log = {
    user_id: +token.getDecoded().id,
    item_id: null,
    assigned_to: null,
    log_date: null,
    message: {
      text: ''
    }
  };
  @observable attachment_file = null;
  @observable ticketStationInventoryItems = [];
  @observable isLoading = false;

  @action onToggleLogNote = e => this.logNote = !this.logNote;
  @action onChangeLogMessage = e => this.log.message.text = e.target.value;
  @action onChangeItem = e => this.log.item_id = e.target.value;
  @action onChangeAssignedTo = e => this.log.assigned_to = e.target.value;
  onOpenClick = () => this.refs.dropzone.open();

  dispose
  componentWillMount() {
    const { ticketStore, inventoryItemStore, inventoryProductStore } = this.props;
    // inventoryItemStore.fetchItems();
    inventoryProductStore.fetchItems();
    this.dispose = autorun(() => {
      let ticket = ticketStore.findById(this.props.ticket_id);
      api.stationInventory.item
        .list(ticket.station_id)
        .then(res => {
          this.ticketStationInventoryItems = res;
        })
    })
  }

  onDrop = files => this.attachment_file = files[0];

  onLogNote = e => {
    e.preventDefault();
    /*

     logObject = {
       user_id: '',
       item_id: '',
       assigned_to: '',
       log_date: '',
       message: {text: ''},
       followers: [array if user id],
       sender: {name: '', email: ''},
       email: {subject: '', link: 'link to tss to view the ticket in tss'}
       attachment: {}
     }

      */
    const { ticketStore, stationStore, userStore, ticket_id } = this.props;
    const { notify } = this.context;
    this.isLoading = true;

    const url = `${BASE_URL}/mms/ticket/${this.props.ticket_id}/log`;
    let ticket = ticketStore.findById(ticket_id),
      station = stationStore.findById(ticket.station_id),
      log = Object.assign({}, toJS(this.log)),
      sender = _.pick(token.getDecoded(), ['name', 'email']);

    log.log_date = new Date();
    log.followers = ticketStore.getCheckedFollowers.map(follower => follower.email);
    log.sender = { name: sender.name, email: sender.email };

    log.email = {
      subject: `Ticket #${this.props.ticket_id}, ${station.name}, ${ticket.summary}`,
      link: window.location.href
    };

    const req = request
      .post(url)
      .set('Authorization', `Bearer ${token.getEncoded()}`);


    if (this.attachment_file) req.field('data', JSON.stringify(log)).attach('file', this.attachment_file);
    else req.set('content-type', 'application/json').send(log);

    req.end((err, res) => {
      this.isLoading = false;
      if (err) console.log(err)
      else {
        const user = token.getDecoded();
        this.log = {
          user_id: +user.id,
          item_id: null,
          assigned_to: null,
          log_date: null,
          message: {
            text: ''
          },
        };
        this.attachment_file = null;
        this.props.ticketStore.pushLog(Object.assign({}, log, { name: user.name, email: user.email }), res.body.src);
        this.onToggleLogNote();
        ticketStore.fetchItem(ticket_id, true);
        notify.success({ message: 'Log added' });
        if (res.body.mail) notify.success({ message: 'Email sent' });
        else notify.error({ message: 'Email not sent' });
      }
    })

  };

  renderLogInputArea = () => {
    const { inventoryProductStore, userStore } = this.props;

    let inventoryItems = this.ticketStationInventoryItems.map(item => {
      let product = inventoryProductStore.findById(item.product_id)
      return {
        id: item.id,
        name: `${!!product ? product.pcategory_name : ''} - ${item.serial_no}`
      }
    });

    return (
      <div className={'bordered indented-form'} style={{ padding: '20px', margin: 0 }}>
        <Form>
          <FormBody>
            <div className='formInput flex fill-parent'>
              <textarea value={this.log.message.text} onChange={this.onChangeLogMessage} placeholder='Write something...' />
            </div>
            <br />
            <div className='inline-grid space-between v-center'>
              <div>
                <SelectInput label='Assigned To' options={userStore.items} fields={{ value: 'id', label: 'name' }} value={this.log.assigned_to} onChange={this.onChangeAssignedTo} />
                <SelectInput label='Item' options={inventoryItems} fields={{ value: 'id', label: 'name' }} value={this.log.item_id} onChange={this.onChangeItem} />
              </div>
              <ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }} />
              {this.attachment_file ?
                <div>
                  {this.attachment_file.name}
                  <span className='fa fa-remove' onClick={() => this.attachment_file = null} />
                </div> :
                <span data-toggle="tooltip" title='Attach file' className='fa fa-paperclip align-v' onClick={this.onOpenClick} />}
            </div>
          </FormBody>
          <FormActions>
            <button className='button' onClick={this.onToggleLogNote}>Cancel</button>
            <Button label='Save' onClick={this.onLogNote} isLoading={this.isLoading} />
          </FormActions>
        </Form>
      </div>
    )
  };

  render() {
    const { ticketStore, inventoryItemStore } = this.props;
    let groupedLogs = ticketStore.ticket_logs ? _.groupBy(ticketStore.ticket_logs, item => moment(item.log_date).format('YYYY-MM-DD')) : null;

    return (
      <div className='full-width'>
        {!this.logNote && <button className={'button button-inactive'} onClick={this.onToggleLogNote}>{'Log note'}</button>}
        {this.logNote && this.renderLogInputArea()}<br />

        {groupedLogs && <div className='logs-container'>{Object.keys(groupedLogs).sort((a, b) => (new Date(a)).valueOf() < (new Date(b)).valueOf() ? 1 : -1).map(key => <Log key={`ticket_log_${key}`} date={key} logs={groupedLogs[key]} />)}</div>}

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/Log/TicketLogRoot.js